import { Box, Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import React from 'react';
import {
  CustomFieldDefinition,
  InputType,
  ValueType,
} from '../../../types/resources/CustomFieldDefinition';
import { ActionSelect } from '../ActionSelect';
import styles from './styles.module.scss';

type CustomFieldFormProps = {
  field: CustomFieldDefinition;
  value: string | string[];
  onChange: (value: string | string[]) => void;
};

export const CustomFieldForm = ({ field, value, onChange }: CustomFieldFormProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    onChange(e.target.value);
  };

  const handleSelectChange = (e: string | number) => {
    onChange(e as string);
  };

  const handleMultiChoiceChange = (option: string) => {
    const currentValues = value ? (Array.isArray(value) ? value : [value]) : [];
    const newValues = currentValues.includes(option)
      ? currentValues.filter(v => v !== option)
      : [...currentValues, option];
    onChange(newValues);
  };

  const renderField = () => {
    if (!field) return null;

    const inputType = field.input_type as InputType;
    const valueType = field.value_type as ValueType;

    switch (inputType) {
      case 'plain':
        return (
          // NOTE: ActionInputを使うと、float型の入力でバグるのでinputを直接使う
          <input
            id={field.id.toString()}
            className={styles.input}
            type={valueType === 'int' || valueType === 'float' ? 'number' : 'text'}
            value={value || ''}
            onChange={handleChange}
          />
        );
      case 'choice':
        return (
          <ActionSelect
            items={
              Object.entries(field.options || {}).map(([key, optionValue]) => ({
                label: optionValue,
                value: key,
              })) || []
            }
            value={(value as string) || ''}
            onChange={e => handleSelectChange(e)}
            defaultValue={''}
            noSelect={true}
          />
        );
      case 'multi_choice': {
        const values = value ? (Array.isArray(value) ? value : [value]) : [];
        return (
          <div className={styles.checkBox}>
            {Object.entries(field.options || {}).map(([key, optionValue]) => (
              <FormGroup key={key}>
                <FormControlLabel
                  control={
                    <Checkbox
                      id={key}
                      value={values}
                      checked={values.includes(key)}
                      onChange={() => handleMultiChoiceChange(key)}
                    />
                  }
                  label={optionValue}
                />
              </FormGroup>
            ))}
          </div>
        );
      }

      default:
        return null;
    }
  };

  return <Box sx={{ mb: 2 }}>{renderField()}</Box>;
};
